import {APP_INITIALIZER, DEFAULT_CURRENCY_CODE, LOCALE_ID, NgModule} from '@angular/core';
import {CommonModule, registerLocaleData} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ProvidersReportsComponent} from './components/providers-reports/providers-reports.component';
import {MatCardModule} from '@angular/material/card';
import {MatInputModule} from '@angular/material/input';
import {MatSelectModule} from '@angular/material/select';
import {FuseAlertModule} from '@fuse/components/alert';
import {MatButtonModule} from '@angular/material/button';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatTableModule} from '@angular/material/table';
import {MatTabsModule} from '@angular/material/tabs';
import localEs from '@angular/common/locales/es-MX';
import {MatDialogModule} from '@angular/material/dialog';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatSortModule} from '@angular/material/sort';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {MatIconModule} from '@angular/material/icon';
import {MatMenuModule} from '@angular/material/menu';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {CompaniesSelectorComponent} from './components/companies-selector/companies-selector.component';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatListModule} from '@angular/material/list';
import {ToUppercaseDirective} from '@directives/to-uppercase.directive';
import {ToLowercaseDirective} from '@directives/to-lowercase.directive';
import {IconService} from '@services/icon.service';
import {ContractsComponent} from '@shared/components/contracts/contracts.component';
import {FianzasComponent} from '@shared/components/fianzas/fianzas.component';
import {PolizasComponent} from '@shared/components/polizas/polizas.component';
import {RouterModule} from '@angular/router';
import {MatTooltipModule} from '@angular/material/tooltip';
import {NgxMatFileInputComponent} from '@ngxmc/file-input';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatMomentDateModule} from '@angular/material-moment-adapter';
import {RegionSelectorComponent} from './components/region-selector/region-selector.component';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {NgxCurrencyDirective} from 'ngx-currency';
import {SelectAllDirective} from '@directives/select-all.directive';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {PaymentBlockSwitchComponent} from '@shared/components/payment-block-switch/payment-block-switch.component';
import {PaymentBlockBadgeComponent} from '@shared/components/payment-block-badge/payment-block-badge.component';
import {PaymentBlockReasonDialogComponent} from '@shared/components/payment-block-reason-dialog/payment-block-reason-dialog.component';
import {PaymentBlockFeatureToggleComponent} from '@shared/components/payment-block-feature-toggle/payment-block-feature-toggle.component';

import {SiseLoaderComponent} from './components/sise-loader/sise-loader.component';

registerLocaleData(localEs, 'es-MX');

const components: any[] = [
    SiseLoaderComponent,
    ProvidersReportsComponent,
    CompaniesSelectorComponent,
    ContractsComponent,
    FianzasComponent,
    PolizasComponent,
    PaymentBlockSwitchComponent,
    PaymentBlockBadgeComponent,
    PaymentBlockReasonDialogComponent,
    PaymentBlockFeatureToggleComponent
];

export const initializeIcons: ((iconService: IconService) => () => void) = (iconService: IconService): (() => void) => (): void => iconService.registerIcons();

@NgModule({
    declarations: [
        components,
        ToUppercaseDirective,
        ToLowercaseDirective,
        SelectAllDirective,
        RegionSelectorComponent
    ],
    imports: [
        CommonModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        MatCardModule,
        MatButtonModule,
        MatButtonToggleModule,
        MatInputModule,
        MatSidenavModule,
        MatIconModule,
        MatSelectModule,
        MatSnackBarModule,
        FuseAlertModule,
        MatProgressBarModule,
        MatTableModule,
        MatPaginatorModule,
        MatSortModule,
        MatMenuModule,
        MatDialogModule,
        MatProgressSpinnerModule,
        MatTabsModule,
        MatCheckboxModule,
        MatListModule,
        MatTooltipModule,
        NgxMatFileInputComponent,
        MatDatepickerModule,
        MatDialogModule,
        MatMomentDateModule,
        NgxCurrencyDirective,
        MatSlideToggleModule
    ],
    exports: [
        CommonModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        MatCardModule,
        MatButtonModule,
        MatButtonToggleModule,
        MatInputModule,
        MatSidenavModule,
        MatIconModule,
        MatSelectModule,
        MatSnackBarModule,
        FuseAlertModule,
        MatProgressBarModule,
        MatTableModule,
        MatPaginatorModule,
        MatSortModule,
        MatMenuModule,
        MatDialogModule,
        MatTabsModule,
        MatCheckboxModule,
        MatListModule,
        MatDatepickerModule,
        MatDialogModule,
        MatProgressSpinnerModule,
        MatTooltipModule,
        NgxMatFileInputComponent,
        MatMomentDateModule,
        components,
        ToLowercaseDirective,
        ToUppercaseDirective,
        NgxCurrencyDirective,
        SelectAllDirective,
        MatSlideToggleModule
    ],
    providers: [
        IconService,
        {
            provide: APP_INITIALIZER,
            useFactory: initializeIcons,
            deps: [IconService],
            multi: true
        },
        {
            provide: LOCALE_ID,
            useValue: 'es-MX'
        },
        {
            provide: DEFAULT_CURRENCY_CODE,
            useValue: 'MXN'
        }
    ]
})
export class SharedModule {
}
